<div tabindex="0">
    <app-app-nav></app-app-nav>
    <main id="mainContent" tabindex="-1">

        <!-- HERO -->
        <section class="pb-0 position-relative">
            <div class="position-relative faculty-hero d-flex">
                <div class="slid-img position-absolute w-100 h-100 top-0 start-0 overflow-hidden">
                    <img class="position-absolute" src="{{faculty_image}}" alt="" />
                    <div class="black-layer position-absolute top-0 start-0 h-100 w-100"></div>
                </div>
                <div
                    class="position-relative d-flex align-items-lg-end justify-content-center institute-pref flex-column">
                    <div class="blend-darken-bg position-absolute top-0 start-0 h-100 w-100"></div>
                    <div class="pref position-relative text-white pe-lg-5 pe-3 ms-3 animate__animated animate__slideInRight wow">
                        <h1 class="heading-font d-inline-block pt-5">
                            <label class="d-block text-sm-end">{{CONSTRUCTION_NAME}}</label>
                            {{title}}
                        </h1>
                    </div>
                </div>
                <div class="position-absolute start-0 bottom-0 container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb animate__animated animate__fadeInDown">
                            <li class="breadcrumb-item"><a class="text-white" routerLink="/">أكادميه الفنون</a></li>
                            <li class="breadcrumb-item"><a class="text-white" (click)="back()" style="cursor:pointer" role="button" tabindex="0" (keydown.enter)="back()" (keydown.space)="back()">{{CONSTRUCTION_NAME}}</a></li>
                            <li class="breadcrumb-item active text-white" aria-current="page">{{title}}</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </section>

        <!-- SECTION NAV (tabs) -->
        <nav class="constr-nav">
            <div class="container-fluid">
                <ul class="constr-nav-list list-unstyled mb-0">
                    <li><a [routerLink]="['/constrction', id]" fragment="about">نبذة</a></li>
                    <li *ngIf="has(CONSTRUCTIONObj?.ACT_PERSON_NAME)">
                        <a [routerLink]="['/constrction', id]" fragment="head">كلمة المسؤول</a></li>
                    <li *ngIf="subdetailslist?.length">
                        <a [routerLink]="['/constrction', id]" fragment="sections">الأقسام</a></li>
                    <li *ngIf="galleryArry?.length">
                        <a [routerLink]="['/constrction', id]" fragment="gallery">معرض الصور</a></li>
                    <li><a [routerLink]="['/constrction', id, 'news']" [class.active]="type === 'news'">الأخبار</a></li>
                    <li><a [routerLink]="['/constrction', id, 'events']"
                            [class.active]="type === 'events'">الفعاليات</a></li>
                </ul>
            </div>
        </nav>

        <div class="container-fluid">
            <section class="constr-section">

                <!-- Items listing (news / events) -->
                <div class="row" *ngIf="items?.length">
                    <a *ngFor="let item of items" class="col-lg-4 col-md-6 mb-4 text-decoration-none"
                        (click)="openItem(item)" role="button" tabindex="0"
                        (keydown.enter)="openItem(item)" (keydown.space)="openItem(item)">
                        <div class="feed-card h-100">
                            <div class="feed-card-media">
                                <img [src]="item.IMG_PATH" loading="lazy" alt="">
                                <span class="feed-card-date" *ngIf="itemDate(item)">{{itemDate(item) | date:'yyyy/MM/dd'}}</span>
                            </div>
                            <div class="feed-card-body">
                                <h3 class="feed-card-title heading-font">{{item.TITLE}}</h3>
                                <p class="feed-card-place" *ngIf="type === 'events' && has(item.Place)">
                                    <i class="icon-location"></i> {{item.Place}}
                                </p>
                            </div>
                        </div>
                    </a>
                </div>

                <!-- Load more (pagination) -->
                <div class="text-center pt-2 pb-4" *ngIf="items?.length && hasMore">
                    <a (click)="moreItems()" class="more-news-btn d-inline-flex align-items-center fw-medium"
                        role="button" tabindex="0" (keydown.enter)="moreItems()" (keydown.space)="moreItems()">
                        المزيد من {{title}}
                        <i class="icon-arrow-sm"></i>
                    </a>
                </div>

                <!-- Empty state -->
                <div class="feed-empty" *ngIf="!items?.length && !loading">
                    <svg viewBox="0 0 24 24" width="46" height="46" fill="none" stroke="currentColor"
                        stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" />
                        <path d="M16 2v4M8 2v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
                    </svg>
                    <h3>لا توجد {{titleBare}} متاحة حاليًا</h3>
                    <p>سيتم عرض {{title}} الخاصة بـ{{CONSTRUCTION_NAME}} هنا فور توفّرها.</p>
                    <button class="btn btn-outline-primary mt-2" (click)="back()">العودة إلى صفحة المنشأة</button>
                </div>

            </section>
        </div>

    </main>
</div>
